const [PERFORM, LEARN, LMS, RECRUIT, SUITE, TEAM, MY_DETAILS, HR, IDENTITY_ADMIN, REPORTING] = ['Perform', 'Learn', 'LMS', 'Recruit', 'Suite', 'Team', 'MyDetails', 'HR', 'IdentityAdmin', 'Reporting'];
export const PRODUCT_NAMES = {
  LEARN,
  LMS,
  PERFORM,
  RECRUIT,
  SUITE,
  TEAM,
  MY_DETAILS,
  HR,
  IDENTITY_ADMIN,
  REPORTING
};
export const LOAD_STATES = {
  UNLOADED: 'UNLOADED',
  LOADING: 'LOADING',
  LOADED: 'LOADED',
  LOAD_ERROR: 'LOAD_ERROR'
};
/**
 * Object representing a tab in the global nav.
 *
 * The product name allows multiple tabs to be grouped as part of the same product.
 * For example /home and /mydetails are separate tabs that are grouped as part of the Suite product.
 *
 * The global nav will only be rendered if there is more than one distinct product name in the accessible tabs.
 * For example the global nav will be hidden if the accessible tabs are /home and /myteam because they have the same product name.
 * For example the global nav will be rendered if the accessible tabs are /home and /learn because they have different product names.
 *
 * @typedef {{name: string, productName: string, url: string}} ProductTab
 *
 * @property {string} name - The name of the tab in the global nav.
 * @property {string} productName - The name of the product that the tab is grouped as part of.
 * @property {string} url - The path that the tab should route to.
 */

/**
 * Array of objects representing the tabs in the global nav.
 *
 * @type {ProductTab[]}
 */

export const PRODUCTS_URLS = [{
  name: SUITE,
  productName: SUITE,
  url: '/home'
}, {
  name: TEAM,
  productName: SUITE,
  url: '/myteam'
}, {
  name: MY_DETAILS,
  productName: SUITE,
  url: '/mydetails'
}, {
  name: LEARN,
  productName: LEARN,
  url: '/learn'
}, {
  name: LMS,
  productName: LMS,
  url: '/LMS'
}, {
  name: PERFORM,
  productName: PERFORM,
  url: '/perform'
}, {
  name: RECRUIT,
  productName: RECRUIT,
  url: '/recruit'
}, {
  name: HR,
  productName: HR,
  url: '/hr/new'
}, {
  name: IDENTITY_ADMIN,
  productName: IDENTITY_ADMIN,
  url: '/identity/admin'
}, {
  name: REPORTING,
  productName: REPORTING,
  url: '/reporting'
}];
export const ERROR_MESSAGES = {
  NO_ACCESSIBLE_PRODUCTS: 'No accessible products were found!',
  GET_CURRENT_PRODUCT_NOT_ACCESSIBLE: (currentProductName = '') => `${currentProductName} is not accessible!`
};
export const IS_DEV_ENV = process.env.NODE_ENV === 'development';
//# sourceMappingURL=constants.js.map